import { createSelector } from 'reselect';

export const billSelector = (state: any) => state.bills;

export const billValueSelector = createSelector(billSelector, (payload) => payload.billValue);

export const selectedBillsValueSelector = createSelector(billSelector, (payload) => {
	return payload.selectedBills || [];
});
